/**
 * Configuração de resposividade para ser adicionar nos gráficos do sistema.
 * Configura o título de cada série para ser apresentado na esquerda
 */
export const configResponsividade = {
	rules: [
		{
			condition: {
				maxWidth: 500,
			},
			chartOptions: {
				subtitle: {
					y: 0,
				},
				legend: {
					align: 'center',
					verticalAlign: 'bottom',
					layout: 'horizontal',
				},
				yAxis: {
					labels: {
						align: 'left',
						x: 0,
						y: -5,
					},
					title: {
						text: null,
					},
				},
				credits: {
					enabled: false,
				},
				noData: {
					useHTML: true,
					position: {
						x: 0,
						y: 0,
						align: 'center',
						verticalAlign: 'middle',
					},
					style: {
						fontSize: '7px',
						fontWeight: 'small',
						overflow: 'hidden',
						lineHeight: '1.2',
					},
				},
			},
		},
		{
			condition: {
				minWidth: 0,
			},
			chartOptions: {
				rangeSelector: {
					y: -26,
				},
			},
			noData: {
				useHTML: true,
				position: {
					align: 'center',
					verticalAlign: 'middle',
				},
				style: {
					fontSize: '12px',
					fontWeight: 'normal',
				},
			},
		},
		{
			condition: {
				minWidth: 300,
			},
			chartOptions: {
				rangeSelector: {
					y: -14,
				},
				noData: {
					useHTML: true,
					position: {
						x: 0,
						y: 0,
						align: 'center',
						verticalAlign: 'middle',
					},
					style: {
						fontSize: '10px',
						fontWeight: 'normal',
					},
				},
			},
		},
		{
			condition: {
				minWidth: 560,
			},
			chartOptions: {
				rangeSelector: {
					y: 20,
				},
				subtitle: {
					y: 14,
				},
			},
		},
	],
};
